"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _product = require("@/api/product");
var _lodash = require("lodash");
var _vuePropertyDecorator = require("vue-property-decorator");
var _function = require("@/utils/function");
var _utils = require("@/utils");
var AddProductOrderModal = /*#__PURE__*/function (_Vue) {
  function AddProductOrderModal() {
    var _this;
    (0, _classCallCheck2.default)(this, AddProductOrderModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, AddProductOrderModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "productsSelected", void 0);
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "customerId", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "products", []);
    (0, _defineProperty2.default)(_this, "lotnumbers", []);
    (0, _defineProperty2.default)(_this, "listProductWithLotNumbers", {});
    // object danh sách productId với data là lotNumbers
    (0, _defineProperty2.default)(_this, "productSelect", {});
    return _this;
  }
  (0, _inherits2.default)(AddProductOrderModal, _Vue);
  return (0, _createClass2.default)(AddProductOrderModal, [{
    key: "handleChangeProduct",
    value: function handleChangeProduct(val) {
      this.lotnumbers = [];
      this.$set(this.form, "indexLotNumber", null);
      this.fetchOrderLotNumber();
    }
  }, {
    key: "handleSelectLotNumber",
    value: function handleSelectLotNumber(val) {
      var lotNumber = this.lotnumbers[val];
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), lotNumber);
    }
  }, {
    key: "checkExist",
    value: function checkExist(product) {
      return this.productsSelected.some(function (e) {
        return e.id == product.id;
      });
    }
  }, {
    key: "fetchProduct",
    value: function () {
      var _fetchProduct = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.loading = true;
              _context.next = 4;
              return _product.productApi.findConsigns({
                customerId: this.customerId,
                type: this.type
              });
            case 4:
              res = _context.sent;
              data = (0, _function.transformDepositOrderDetails)(res.data.products, this.status, this.productSelect);
              this.products = data.products;
              this.listProductWithLotNumbers = data.listProductWithLotNumbers;
            case 8:
              _context.prev = 8;
              this.loading = false;
              return _context.finish(8);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0,, 8, 11]]);
      }));
      function fetchProduct() {
        return _fetchProduct.apply(this, arguments);
      }
      return fetchProduct;
    }()
  }, {
    key: "fetchOrderLotNumber",
    value: function () {
      var _fetchOrderLotNumber = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var firstLotNumber;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _utils.sleep)(200);
            case 2:
              this.lotnumbers = this.listProductWithLotNumbers[this.form.product.id];
              if (this.lotnumbers.length) {
                this.$set(this.form, "indexLotNumber", 0);
                firstLotNumber = (0, _objectSpread2.default)({}, this.lotnumbers[0]);
                delete firstLotNumber.product;
                this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), firstLotNumber);
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchOrderLotNumber() {
        return _fetchOrderLotNumber.apply(this, arguments);
      }
      return fetchOrderLotNumber;
    }()
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context3.sent;
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context4.sent;
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleSave",
    value: function handleSave() {
      if ((0, _lodash.isEmpty)(this.form.lotNumber)) {
        return this.$message.error("You must choose lot number");
      }
      this.$emit("choose", this.form);
      this.visible = false;
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.visible = true;
      this.status = "create";
      this.form = {};
      this.fetchProduct();
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(index, data) {
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        indexProduct: index
      });
      this.visible = true;
      this.status = "update";
      this.fetchProduct();
      this.fetchOrderLotNumber();
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], AddProductOrderModal.prototype, "productsSelected", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], AddProductOrderModal.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], AddProductOrderModal.prototype, "customerId", void 0);
AddProductOrderModal = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], AddProductOrderModal);
var _default = exports.default = AddProductOrderModal;